import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { OrganizationsService } from '../../../inputfileds/form_services/organization/organizations.service';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { forkJoin, Observable } from 'rxjs';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-addsuborganisation',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatCheckboxModule,
    MatDividerModule,
    MatTableModule,
    RouterModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    DynamicFormQuestionComponent,
    CommonModule,
    TranslateDirective
  ],
  providers: [
    QuestionControlService,
    OrganizationsService,
    ApiservicesService,
    DropdownservicesService
  ],
  templateUrl: './addsuborganisation.component.html',
  styleUrl: './addsuborganisation.component.scss'
})

export class AddsuborganisationComponent {
  suborganisationquestions: [] = [];
  suborganisationquestions$: Observable<any[]> | null = null;
  suborganisationpersonal_detailsquestions: [] = [];
  suborganisationpersonal_detailsquestions$: Observable<any[]> | null = null;
  suborganisationForm!: FormGroup;
  suborganisationpersonal_detailsForm!: FormGroup;
  payLoad: any;
  datesend: any;
  file: any;
  fileName: any;
  fomdata: FormData = new FormData()
  selectedImageUrl!: string | ArrayBuffer | null;
  errorMessage!: string;
  @ViewChild('alertDialog') alertDialog!: TemplateRef<any>;

  constructor(
    private dialogRef: MatDialogRef<AddsuborganisationComponent>,
    public suborganisationService: OrganizationsService,
    private qcs: QuestionControlService,
    private fb: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    public apiService: ApiservicesService,
    private dropdownservice: DropdownservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.suborganisationquestions$ = suborganisationService.getOrganizationservices();
    this.suborganisationquestions$.subscribe((q: any) => this.suborganisationquestions = q);
    this.suborganisationpersonal_detailsquestions$ = suborganisationService.getOrganizationpersonal_detailsservices();
    this.suborganisationpersonal_detailsquestions$.subscribe((q: any) => this.suborganisationpersonal_detailsquestions = q);
  }

  ngOnInit(): void {
    // this.suborganisationFrom = this.fb.group({});
    // this.suborganisationpersonal_detailsFrom = this.fb.group({});
    this.suborganisationForm = this.qcs.toFormGroup(this.suborganisationquestions as Inputfiledsbase<string>[]);
    this.suborganisationpersonal_detailsForm = this.qcs.toFormGroup(this.suborganisationpersonal_detailsquestions as Inputfiledsbase<string>[]);
  }

  closeDialog(event: any) {
    this.dialogRef.close(event);
    // document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeIn")
    // document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOut");
    // setTimeout(() => { this.dialogRef.close(event); }, 1000);
  }

  imageInputChange(fileInputEvent: any): void {
    this.file = fileInputEvent.target.files[0];
    this.fileName = fileInputEvent.target.files[0].name;
    this.fomdata.append('employeImage', this.file);
    if (this.file) {
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        this.selectedImageUrl = reader.result;
      };
    }
  }

  updateImage(file: File, id: number): void {
    this.apiService.updatesuborganizationimage(file, id).subscribe(
      (res) => {
        this.closeDialog(false);
      },
      (err) => {
        console.error('Image upload error', err);
        this.errorMessage = 'Image upload failed. Please try again.';
      }
    );
  }

  onSubmit() {
    this.payLoad = this.suborganisationForm.getRawValue();
    this.payLoad = { ...this.payLoad, "personal_details": this.suborganisationpersonal_detailsForm.getRawValue(), "logo_url": null, "educational_qualifications": [], "addresses": [], "experience_details": {}, "salary_deatails": {}, "joining_details": {} }
    this.datesend = this.suborganisationForm.value;
    this.createAPis(this.payLoad);
    // this.closeDialog(true)
    // let user_session_data = JSON.parse(sessionStorage.getItem('user') || '');
    // let sub_org_session_data = JSON.parse(sessionStorage.getItem('SubOrgData') || '');
    // user_session_data.data.onboarding_status = false;
    // sub_org_session_data.onboarding_status = false;
    // console.log("working", user_session_data);
    // sessionStorage.setItem('user', JSON.stringify(user_session_data));
    // sessionStorage.setItem('SubOrgData', JSON.stringify(sub_org_session_data));
    // this.router.navigate(['onboarding']);
    // setTimeout(() => {
    //   window.location.href = this.router.url;
    // }, 2000)
    // forkJoin([
    //   this.dropdownservice.getlookupcodesdropdown('DESIGNATIONS'),
    // ]).subscribe(([designationRes]) => {
    //   const filteredStatus = designationRes.filter((dropfilter: any) => { return dropfilter.id === this.suborganisationForm.value.designation_id });
    //   this.payLoad = { ...this.payLoad, designation: filteredStatus[0]?.lookup_name };
    //   // this.payLoad.maximum_allowed_leaves = parseInt(this.form.value.maximum_allowed_leaves);
    //   this.createAPis(this.payLoad);
    // });
  }

  createAPis(event: any) {
    this.apiService.createsuborganization(event).subscribe((res: any) => {
      if (res.code === 201 && res.status === true) {
        if (this.data == 0) {
          this.openCreateSectionDialog();
          this.closeDialog(true);
        }
        this.suborganisationForm.reset();
        this.suborganisationpersonal_detailsForm.reset();
        if (this.file) {
          this.updateImage(res.data.id, this.file);
        } else {
          this.closeDialog(true);
        }
      }
    })
  }

  navigatetoonboarding() {
    this.router.navigate(['onboarding']);
  }
  openCreateSectionDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__fadeIn'];
    dialogConfig.minWidth = '80%';
    dialogConfig.minHeight = '65vh';
    dialogConfig.maxHeight = '65vh';
    const dialogRef = this.dialog.open(this.alertDialog, {
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(result => { });
  }
  closealertDialog(event: any) {
    this.dialog.closeAll();
  }
}
